import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { Skeleton } from '@src/shared/ui/components/Widget/components/Skeleton';
import { isEmpty } from 'lodash';
import React from 'react';

import { Table } from './components/Table';

/**
 * Widget: RiskScore
 *
 * @TODO Needs description.
 *
 * @param data
 * @returns {Element}
 * @constructor
 */
export function RiskScore({ data = {} }) {
  return (
    <ErrorHandler location="src/widgets/RiskRecords/RiskScore/RiskScore.jsx">
      {isEmpty(data) ? (
        <Skeleton />
      ) : (
        <Widget description={data?.description || ''} title={data?.name || 'Risk Score'}>
          {data?.defaultView === 'table' && (
            <Table
              rows={data?.data?.content?.map((row) => {
                return {
                  amount: row?.total,
                  score: row?.label,
                };
              })}
            />
          )}
        </Widget>
      )}
    </ErrorHandler>
  );
}
